export default __webpack_public_path__ + "static/media/warrantyManagement3-2.49a522ee.png";